import { render } from "./PropertyExpense.vue?vue&type=template&id=b345a05a"
import script from "./PropertyExpense.vue?vue&type=script&lang=js"
export * from "./PropertyExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__